export default __webpack_public_path__ + "static/media/gamer_1.8e4211fa.png";